import React, { Component } from 'react'
import { toast } from 'react-toastify'
import _ from 'lodash'
import { connect } from 'react-redux'
import { convertSearchObjectToBase64 } from 'utils/objToBase64'

import { GetWithNonce } from 'utils/axios-nonce'
import { SearchParams } from '../assets'
import { Get, Post, Put, Delete } from 'utils/axios-token'
import Lang from 'Lang/General'

const HOC = (WrappedComponent) => {
  class WithHOC extends Component {
    state = {
      showCreatePortalUsers: false,
      loading: false,
      portalUsers: [],
      portalUsersMeta: {
        current_page: 1,
        per_page: 10,
        last_page: 1,
        total_results: 1
      },
      errors: {},
      currentView: 'EXHIBITOR',
      searchParams: SearchParams(this.props),
      defaultSearchParams: [],
      defaultQuery: {},
      selectedBooking: null,
      selectedPortalUsers: {},
      showEditModal: false,
      subscribedPackage: false,
      showDeleteConfirmation: false,
      showViewPortalUsersModal: false,
      showLogModal: false,
      showMediaModal: false,
      showUploadModal: false,
      logsList: [],
      query: {},

      countries: [],
      fairs: [],
      industries: [],
      updatingConfirmed: false,
      isShowingAll: false,
      logRecords: []
    }

    onChangePortalUsersHOC = (key, val) => this.setState({ [key]: val })

    roleValueHandler = () => {
      let tempView = 'EXHIBITOR'

      if (this.props.history.location.pathname.indexOf('consultants') > -1) {
        tempView = 'CONSULTANT'
      }
      if (this.props.history.location.pathname.indexOf('speakers') > -1) {
        tempView = 'SPEAKER'
      }

      return tempView
    }


    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success(success)
    requestError = error => {
      typeof error === 'string'
        ? toast.error(error)
        : Object.values(error).map(item => toast.error(item.replace(/_/g, ' ')))
    }

    getPortalUsers = (query) => {
      this.setState({ query })

      Get(
        `/api/v1/fex/portal_users?query=${convertSearchObjectToBase64(query)}`,
        this.getPortalUsersSuccess,
        this.getPortalUsersError,
        this.load
      )
    }
    getPortalUsersSuccess = payload => this.setState({
      portalUsers: payload.data,
      portalUsersMeta: payload.meta
    })
    getPortalUsersError = error => this.requestError(error.toString())

    getFairsLogs = portalUserID => Get(
      `/api/v1/fex/logs?query=${convertSearchObjectToBase64({ "is_paginated": false, "filter": { "user_id": portalUserID } })}`,
      this.getFairsLogsSuccess,
      this.getFairsLogsError,
      this.load
    )
    getFairsLogsSuccess = payload => this.setState({ logsList: payload.data })
    getFairsLogsError = error => this.requestError(error)

    createPortalUsers = dataToSubmit => {
      Post(
        `/api/v1/fex/portal_users`,
        dataToSubmit,
        this.createPortalUsersSuccess,
        this.createPortalUsersError,
        this.load
      )
    }
    createPortalUsersSuccess = () => {
      this.requestSuccess(Lang['RECORD_CREATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.setState({
        showCreatePortalUsers: false,
        query: {
          page: 1,
          is_paginated: true,
          filter: {
            "client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id,
            "$or": [
              { "role": this.roleValueHandler() },
            ]
          }
        }
      }, () => this.getPortalUsers(this.state.query))
    }
    createPortalUsersError = error => {
      if (typeof error === 'string') {
        return this.requestError(error)
      }

      this.requestError(Lang['RECORD_CREATED_UNSUCCESSFULLY'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.setState({ errors: error })
    }

    getSelectedPortalUsers = id => {
      Get(
        `/api/v1/fex/portal_users/${id}`,
        this.getSelectedPortalUsersSuccess,
        this.getSelectedPortalUsersError,
        this.load
      )
    }
    getSelectedPortalUsersSuccess = payload => this.setState({ selectedPortalUsers: payload, showEditModal: true })
    getSelectedPortalUsersError = error => this.requestError(error)

    updatePortalUsers = (dataToSubmit) => {
      Put(
        `/api/v1/fex/portal_users/${dataToSubmit.id}`,
        dataToSubmit,
        this.updatePortalUsersSuccess,
        this.updatePortalUsersError,
        this.load
      )
    }
    updatePortalUsersSuccess = () => {
      this.requestSuccess(Lang['RECORD_UPDATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.setState({
        showEditModal: false,
        selectedPortalUsers: null,
        query: {
          page: 1,
          is_paginated: true,
          filter: {
            "client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id,
            "$or": [
              { "role": this.roleValueHandler() },
            ]
          }
        }
      }, () => this.getPortalUsers(this.state.query))
    }
    updatePortalUsersError = error => {
      this.requestError(Lang['RECORD_UPDATED_UNSUCCESSFULLY'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.setState({ errors: error })
    }

    getCountries = () => GetWithNonce(
      `/api/v1/countries?language=DEU`,
      this.getCountriesSuccess,
      this.getCountriesError,
      this.load
    )
    getCountriesSuccess = payload => {
      let tempOptions = []
      payload && payload.map(item => {
        tempOptions.push({
          id: item.id,
          label: item.name,
          value: item.name
        })
      })
      this.setState({ countries: tempOptions })
    }
    getCountriesError = error => this.requestError(error)

    resetPW = (id, password, callback) => {
      Put(
        `/api/v1/fex/portal_users/reset_password/${id}`,
        { password },
        () => {
          this.requestSuccess(Lang['RECORD_UPDATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
          callback && callback()
        },
        error => this.requestError(error),
        this.load
      )
    }

    getFairs = () => {
      Get(
        `/api/v1/fex/fairs?query=${convertSearchObjectToBase64({
          page: 1,
          is_paginated: false,
          filter: {
            "client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id,
            "is_active": true
          }
        })}`,
        this.getFairsSuccess,
        this.getFairsError,
        this.load
      )
    }
    getFairsSuccess = payload => {
      let tempOptions = []
      payload.data && payload.data.map(item => {
        tempOptions.push({
          id: item.id,
          label: item.title,
          value: item.title
        })
      })
      this.setState({
        fairs: tempOptions
      })
    }
    getFairsError = error => this.requestError(error.toString())

    getIndustries = () => {
      Get(
        `/api/v1/fex/industries?query=${convertSearchObjectToBase64({
          page: 1,
          is_paginated: false,
          client_id: this.props.data.selectCenterReducer.selectedCenter.center.client_id,
          is_active: true
        })}`,
        this.getIndustriesSuccess,
        this.getIndustriesError,
        this.load
      )
    }
    getIndustriesSuccess = payload => {
      let tempOptions = []
      payload.data && payload.data.map(item => {
        tempOptions.push({
          ...item,
          label: item.title[this.props.data.languageReducer.userSettings.admin_panel_language],
          value: item.title[this.props.data.languageReducer.userSettings.admin_panel_language]
        })
      })
      this.setState({
        industries: tempOptions
      })
    }
    getIndustriesError = error => this.requestError(error.toString())

    updateBooking = dataToSubmit => Put(
      `/api/v1/fex/fairs/${dataToSubmit.fair_id}/bookings/${dataToSubmit.user_id}`,
      dataToSubmit,
      () => {
        this.requestSuccess(Lang['RECORD_UPDATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
        this.setState({
          selectedBooking: null
        })
      },
      error => this.requestError(error),
      this.load
    )

    getSelectedBooking = (portalUserID, fairID) => Get(
      `/api/v1/fex/fairs/${fairID}/bookings/${portalUserID}`,
      payload => this.setState({ selectedBooking: payload }),
      error => this.requestError(error),
      this.load
    )

    getSelectedLog = userID => Get(
      `/api/v1/fex/trafficlightlogs/${userID}`,
      this.getSelectedLogSuccess,
      error => this.requestError(error),
      this.load
    )
    getSelectedLogSuccess = payload => this.setState({
      showLogModal: true,
      logRecords: payload
    })

    render = () => {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          onLoadPortalUsersHOC={this.state.loading}
          getFairs={this.getFairs}
          getSelectedLog={this.getSelectedLog}
          getIndustries={this.getIndustries}
          getSelectedBooking={this.getSelectedBooking}
          resetPW={this.resetPW}
          updateBooking={this.updateBooking}
          getPortalUsers={this.getPortalUsers}
          getFairsLogs={this.getFairsLogs}
          getCountries={this.getCountries}
          createPortalUsers={this.createPortalUsers}
          getSelectedPortalUsers={this.getSelectedPortalUsers}
          updatePortalUsers={this.updatePortalUsers}
          onChangePortalUsersHOC={this.onChangePortalUsersHOC}
        />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect(mapStateToProps)(WithHOC)
}

export default HOC
